import { render, staticRenderFns } from "./VideoSwiper.vue?vue&type=template&id=371a75dc&scoped=true&"
import script from "./VideoSwiper.vue?vue&type=script&lang=js&"
export * from "./VideoSwiper.vue?vue&type=script&lang=js&"
import style0 from "./VideoSwiper.vue?vue&type=style&index=0&id=371a75dc&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371a75dc",
  null
  
)

export default component.exports